<template>
  <div>
    <v-dialog v-model="openModal" width="400">
      <v-carousel height="200" hide-delimiters>
        <v-carousel-item
          v-for="(item, i) in items"
          :key="i"
          :src="item.src"
          reverse-transition="fade-transition"
          transition="fade-transition"
        >
          <v-app-bar height="10" flat color="rgba(0, 0, 0, 0)">
            <v-spacer></v-spacer>
            <v-btn
              color="white"
              fab
              x-small
              class="mt-6 mr-n3"
              @click="closeDialog"
            >
              <v-icon class="pointer red--text">mdi-close</v-icon>
            </v-btn>
          </v-app-bar>
        </v-carousel-item>
      </v-carousel>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      openModal: true,
      items: [
        {
          src: require("@/assets/images/step1.png"),
        },
        {
          src: require("@/assets/images/step2.png"),
        },
        {
          src: require("@/assets/images/step3.png"),
        },
        {
          src: require("@/assets/images/step4.png"),
        },
        {
          src: require("@/assets/images/step5.png"),
        },
      ],
    };
  },
  props: ["openCarouselModal"],

  watch: {
    openModal(value) {
      !value ? this.$emit("update:openCarouselModal", false) : () => {};
    },
  },
  methods: {
    closeDialog() {
      this.$emit("update:openCarouselModal", false);
    },
  },
};
</script>
